import React, { Suspense, useContext } from "react"

import { Paper } from "@material-ui/core"
import { Title } from "App/Component/ui"
import { FormInputPenjualan, STYLE_PENJUALAN, TabMaster } from "./ui"
import { FormProvider } from "./context/FormContext"
import { LoadingBackdrop } from "components/atoms"
import { RenderStatusPembelian } from "../DaftarPenjualan/helpers"
import { FormContext } from "./context/FormContext"
export default function InputPenjualan() {
  const classes = STYLE_PENJUALAN()

  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <FormProvider>
        <div className={classes.root}>
          <TitleStatus />
          <Paper className={classes.paper}>
            <FormInputPenjualan />
            <div
              style={{
                marginTop: "2rem",
              }}
            >
              <TabMaster />
            </div>
          </Paper>
          <ul
            style={{
              fontSize: "11px",
              marginTop: "2rem",
              padding: "1rem",
            }}
          >
            <li>Gunakan F2 untuk memunculkan modal muat kunjungan</li>
            <li>Gunakan F4 untuk memunculkan modal muat list penjualan</li>
            <li>Gunakan F6 untuk untuk reset form penjualan</li>
          </ul>
        </div>
      </FormProvider>
    </Suspense>
  )
}

const TitleStatus = () => {
  const { formData } = useContext(FormContext)

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <Title title={"Input Penjualan"} />
      </div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
        }}
      >
        <RenderStatusPembelian status={formData.status_transaksi} />
      </div>
    </div>
  )
}
